@if (isReady) {
  <div>
    <!-- State 1: Polaris UX (inside shell + usePolarisUx ON) — shell renders header + sidebar -->
    @if (polarisUx) {
      <fdx-grid width="max-width">
        <fdx-grid-row>
          <fdx-grid-item columns="12">
            <div class="fdx-wpro-stickyBanner">
              <wpro-banner-message></wpro-banner-message>
            </div>
            <router-outlet></router-outlet>
            @if (loading) {
              <wpro-spinner-default></wpro-spinner-default>
            }
          </fdx-grid-item>
        </fdx-grid-row>
      </fdx-grid>
    } @else if (showHeadFoot) {
      <!-- State 2: Standalone / dotcom — full header/footer + own sidebar -->
      <ciam-head-foot style="position: relative; z-index: 1;">
        <wpro-side-bar>
          <fdx-grid width="max-width">
            <fdx-grid-row>
              <fdx-grid-item columns="12">
                <div class="fdx-wpro-stickyBanner">
                  <wpro-banner-message></wpro-banner-message>
                </div>
                <router-outlet></router-outlet>
                @if (loading) {
                  <wpro-spinner-default></wpro-spinner-default>
                }
              </fdx-grid-item>
            </fdx-grid-row>
          </fdx-grid>
        </wpro-side-bar>
      </ciam-head-foot>
    } @else {
      <!-- State 3: Inside shell + usePolarisUx OFF — own sidebar, no second header (shell renders SHF) -->
      <wpro-side-bar>
        <fdx-grid width="max-width">
          <fdx-grid-row>
            <fdx-grid-item columns="12">
              <div class="fdx-wpro-stickyBanner">
                <wpro-banner-message></wpro-banner-message>
              </div>
              <router-outlet></router-outlet>
              @if (loading) {
                <wpro-spinner-default></wpro-spinner-default>
              }
            </fdx-grid-item>
          </fdx-grid-row>
        </fdx-grid>
      </wpro-side-bar>
    }
  </div>
}

<!-- Single global Popr2 outlet (modals/toasts). Popr2Queue broadcasts to every outlet, so exactly
     one app-level outlet must exist across all states to avoid duplicate/missing popups. -->
<ciam-popr2></ciam-popr2>
